import { ADD_ISSUERS, IssuersTypes, ISSUERS_ERROR, LOADING_ISSUERS } from '../config/ActionTypes';
import { IssuerState } from '../config/types/issuer.types';

export const initialState: IssuerState = {
  loadingIssuers: false,
  issuers: null,
  issuersErrorMessage: null,
};

export function issuerReducer(state = initialState, action: IssuersTypes): IssuerState {
  switch (action.type) {
    case LOADING_ISSUERS:
      return {
        ...state,
        loadingIssuers: true,
        issuers: null,
        issuersErrorMessage: null,
      };

    case ADD_ISSUERS:
      return {
        ...state,
        loadingIssuers: false,
        issuers: action.issuers,
        issuersErrorMessage: null,
      };

    case ISSUERS_ERROR:
      return {
        ...state,
        loadingIssuers: false,
        issuers: null,
        issuersErrorMessage: action.error,
      };

    default:
      return state;
  }
}
